export default __webpack_public_path__ + "static/media/img (3).fc12c577.jpg";